// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NEV_","textarea":"styles_textarea__1_sB3"};